import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { selectSx, menuSx } from './filterStyles';
import FilterField from './FilterField';

const SingleDropdown = ({ label, field, selected, options, onChange }) => (
  <FilterField label={label}>
    <Select
      fullWidth size="small"
      value={selected}
      onChange={(e) => onChange(field, e.target.value)}
      sx={selectSx}
      MenuProps={menuSx}
    >
      {options.map((opt) => (
        <MenuItem key={opt} value={opt} sx={{ fontSize: 13, '&:hover': { backgroundColor: '#0D2A40' } }}>
          {opt}
        </MenuItem>
      ))}
    </Select>
  </FilterField>
);

export default SingleDropdown;